// src/dates.ts
function toIso(d) {
  return `${String(d.year).padStart(4, "0")}-${String(d.month).padStart(2, "0")}-${String(d.day).padStart(2, "0")}`;
}
function daysInMonth(year, month) {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
function compareDates(a, b) {
  return a.year - b.year || a.month - b.month || a.day - b.day;
}
function toSimpleDate(value) {
  if (value == null) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate()
    };
  }
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!m) return null;
  const d = { year: Number(m[1]), month: Number(m[2]), day: Number(m[3]) };
  if (d.month < 1 || d.month > 12 || d.day < 1 || d.day > daysInMonth(d.year, d.month)) return null;
  return d;
}
function addMonths(d, months) {
  const total = d.year * 12 + (d.month - 1) + months;
  const year = Math.floor(total / 12);
  const month = total % 12 + 1;
  return { year, month, day: Math.min(d.day, daysInMonth(year, month)) };
}
function ageInYears(from, to) {
  let age = to.year - from.year;
  if (to.month < from.month || to.month === from.month && to.day < from.day) age--;
  return age;
}
function parseMrzDate(raw, kind, reference, maxYearsAhead = 20) {
  if (/^<+$/.test(raw)) return { status: "missing", date: null, iso: null };
  if (!/^\d{6}$/.test(raw))
    return { status: raw.includes("<") ? "unknown" : "invalid", date: null, iso: null };
  const yy = Number(raw.slice(0, 2));
  const month = Number(raw.slice(2, 4));
  const day = Number(raw.slice(4, 6));
  if (month < 1 || month > 12 || day < 1 || day > 31)
    return { status: "invalid", date: null, iso: null };
  const base = Math.floor(reference.year / 100) * 100;
  const candidates = [base + 100 + yy, base + yy, base - 100 + yy];
  for (const year of candidates) {
    const date = { year, month, day };
    const fits = kind === "birth" ? compareDates(date, reference) <= 0 : year <= reference.year + maxYearsAhead;
    if (!fits) continue;
    if (day > daysInMonth(year, month)) return { status: "invalid", date: null, iso: null };
    return { status: "ok", date, iso: toIso(date) };
  }
  return { status: "invalid", date: null, iso: null };
}

export {
  toIso,
  compareDates,
  toSimpleDate,
  addMonths,
  ageInYears,
  parseMrzDate
};
//# sourceMappingURL=chunk-QW2F5SQ5.js.map